export default "__VITE_PUBLIC_ASSET__02fa07d2__"